import { Outlet } from '@/core/entity';
import { IOutletGateway, OutletInput, UpdaterFunc, PresenterFunc } from '@/core/interface';

export class UpdateOutlet {
  constructor(
    private readonly outletGw: IOutletGateway,
  ) { }

  public async execute(id: string, input: OutletInput, presenter: PresenterFunc<Outlet | null>, updater?: UpdaterFunc) {
    presenter(null, null, true);

    try {
      const result = await this.outletGw.updateOutlet(id, input, undefined, updater);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }
}
